import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { getCanvasResolution } from '../utils/canvasResolution';
export function Canvas({ onCanvasMount, onCanvasClick, fill = false, className, }) {
    const canvasRef = useRef(null);
    const { width: canvasWidth, height: canvasHeight } = getCanvasResolution();
    const handleRef = useCallback((canvas) => {
        canvasRef.current = canvas;
        onCanvasMount(canvas);
    }, [onCanvasMount]);
    const handleClick = useCallback((event) => {
        if (!onCanvasClick || !canvasRef.current)
            return;
        const rect = canvasRef.current.getBoundingClientRect();
        const canvas = canvasRef.current;
        const clickX = event.clientX - rect.left;
        const clickY = event.clientY - rect.top;
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        const canvasX = clickX * scaleX;
        const canvasY = clickY * scaleY;
        onCanvasClick(canvasX, canvasY);
    }, [onCanvasClick]);
    if (fill) {
        return (_jsx(FillCanvas, { ref: handleRef, width: canvasWidth, height: canvasHeight, className: className, onClick: handleClick }));
    }
    return (_jsx("canvas", { ref: handleRef, width: canvasWidth, height: canvasHeight, className: className, onClick: handleClick }));
}
const FillCanvas = styled.canvas `
    width: 100% !important;
    height: 100% !important;
    display: block;
    object-fit: fill; /* Stretch to fill, ignore aspect ratio */
    pointer-events: auto !important;
    cursor: pointer;
`;
